module.exports = __webpack_public_path__ + "img/shopping-bag.cd357e1c.svg";